/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdatePersonalNotificationsErrorResponse,
  UpdatePersonalNotificationsRequest,
} from './api.schemas';

import { api } from '../util/http';

export const updatePatientNotifications = (
  patientId: string,
  updatePersonalNotificationsRequest: UpdatePersonalNotificationsRequest,
) => {
  return api<void>({
    url: `/api/patient/${patientId}/notifications`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updatePersonalNotificationsRequest,
  });
};

export const getUpdatePatientNotificationsMutationOptions = <
  TError = UpdatePersonalNotificationsErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatientNotifications>>,
    TError,
    { patientId: string; data: UpdatePersonalNotificationsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatientNotifications>>,
  TError,
  { patientId: string; data: UpdatePersonalNotificationsRequest },
  TContext
> => {
  const mutationKey = ['updatePatientNotifications'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientNotifications>>,
    { patientId: string; data: UpdatePersonalNotificationsRequest }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return updatePatientNotifications(patientId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientNotifications>>
>;
export type UpdatePatientNotificationsMutationBody = UpdatePersonalNotificationsRequest;
export type UpdatePatientNotificationsMutationError = UpdatePersonalNotificationsErrorResponse;

export const useUpdatePatientNotifications = <
  TError = UpdatePersonalNotificationsErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatientNotifications>>,
      TError,
      { patientId: string; data: UpdatePersonalNotificationsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatientNotifications>>,
  TError,
  { patientId: string; data: UpdatePersonalNotificationsRequest },
  TContext
> => {
  const mutationOptions = getUpdatePatientNotificationsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
